import { Flex } from "antd";
import { CommonTable } from "components";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useStores } from "stores";
import { getColumns } from "./getColumns";
import { routes } from "constants/routes";

export const PendingActionsContracts = observer(() => {
  const { pendingActionsContractList } = useStores();
  const navigate = useNavigate();

  return (
    <Flex vertical gap="large" className="margin-top-md">
      <CommonTable
        store={pendingActionsContractList}
        updateWithInterval
        columns={getColumns(pendingActionsContractList)}
        onRow={(record) => ({
          onClick: () => navigate(`/${routes.contracts}/${record.id}`),
          className: "cursor-pointer",
        })}
        whiteBox
        widgets={{
          search: true,
          date: true,
        }}
      />
    </Flex>
  );
});
